<template>
  <v-dialog v-model="summaryDialog" max-width="600px" scrollable>
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between py-3">
        <span class="text-subtitle-1 font-weight-medium">Chat Summary</span>
        <v-btn icon small @click="summaryDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <div class="d-flex align-center px-4 pb-3">
        <v-radio-group
          v-model="summaryLanguage"
          row
          hide-details
          dense
          class="mt-0 mr-4 flex-shrink-0"
        >
          <v-radio label="RU" value="ru" color="blue"></v-radio>
          <v-radio label="UZ" value="uz" color="blue"></v-radio>
        </v-radio-group>

        <v-text-field
          v-model.number="summaryDays"
          type="number"
          label="Дней"
          min="1"
          dense
          outlined
          hide-details
          style="max-width: 80px"
          class="mr-2"
        ></v-text-field>

        <v-btn
          icon
          small
          :disabled="summaryLoading"
          :loading="summaryLoading"
          @click="forceRefreshSummary"
          title="Сгенерировать без кэша"
        >
          <v-icon small>mdi-refresh-circle</v-icon>
        </v-btn>
      </div>

      <v-divider />
      <v-card-text style="max-height: 60vh; overflow-y: auto">
        <div v-if="summaryLoading" class="d-flex justify-center py-8">
          <v-progress-circular indeterminate color="blue" />
        </div>
        <div v-else-if="summaryError === 502" class="text-center py-6">
          <div class="grey--text mb-3">
            Ошибка AI сервиса. Попробуйте ещё раз.
          </div>
          <v-btn color="blue" text @click="forceRefreshSummary">
            Повторить
          </v-btn>
        </div>
        <div v-else-if="summaryError" class="text-center py-6">
          <div class="grey--text">Произошла ошибка. Попробуйте позже.</div>
        </div>
        <pre
          v-else-if="summaryText"
          class="summary-text"
          v-html="summaryText"
        ></pre>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import chatSummariesApi from '@/api/chatSummaries';

export default {
  name: 'ChatSummaryModal',

  data() {
    return {
      summaryDialog: false,
      summaryLoading: false,
      summaryText: null,
      summaryError: null,
      summaryLanguage: window.localStorage.getItem('summaryLanguage') || 'ru',
      summaryDays: parseInt(window.localStorage.getItem('summaryDays')) || 7,
    };
  },

  computed: {
    currentChat() {
      return this.$store.getters['chat/currentChat'];
    },
  },

  watch: {
    'currentChat.chatId'() {
      this.summaryDialog = false;
      this.summaryLoading = false;
      this.summaryText = null;
      this.summaryError = null;
    },

    summaryLoading(val) {
      this.$emit('loading', val);
    },

    summaryLanguage(val) {
      window.localStorage.setItem('summaryLanguage', val);
    },

    summaryDays(val) {
      window.localStorage.setItem('summaryDays', String(val));
    },
  },

  methods: {
    open() {
      if (this.summaryText || this.summaryError) {
        this.summaryDialog = true;
        return;
      }
      this.fetchSummary();
    },

    async fetchSummary(force = false) {
      this.summaryLoading = true;
      this.summaryText = null;
      this.summaryError = null;
      try {
        const res = await chatSummariesApi.getSummary(
          this.currentChat.chatId,
          this.summaryLanguage,
          this.summaryDays,
          force
        );
        this.summaryText = res.data.summary;
        if (!this.summaryDialog) this.summaryDialog = true;
      } catch (e) {
        this.summaryError = e.response?.status || 500;
        if (!this.summaryDialog) this.summaryDialog = true;
      } finally {
        this.summaryLoading = false;
      }
    },

    async forceRefreshSummary() {
      this.summaryText = null;
      this.summaryError = null;
      await this.fetchSummary(true);
    },
  },
};
</script>

<style scoped>
.summary-text {
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
  font-size: 0.875rem;
  line-height: 1.6;
  padding: 8px 0;
}
</style>
